import Vue from 'vue'
import {Dictionary, Module} from 'vuex'
import {RootState, PollsState} from '@/types/store/states'
import {RawPoll} from '@/types/entity/RawPoll'
import {RawRecipient} from '@/types/entity/RawRecipient'
import Poll from '@/models/polls/Poll'
import {API} from '@/constants'
import Recipient from '@/models/mailing/recipient'

const store: Module<PollsState, RootState> = {
  namespaced: true,
  state: {
    polls: {},
    recipients: {}
  },
  getters: {
    getPoll: state => (data: RawPoll) => {
      if (state.polls[data.id]) {
        state.polls[data.id].setData(data)
      } else {
        Vue.set(state.polls, data.id, new Poll(data))
      }
      return state.polls[data.id]
    },
    getPolls: (state, getters) => (data: RawPoll[], returnArray: boolean = true) => {
      const result = returnArray ? [] : {};
      for (const item of data) {
        const itemModel = getters.getPoll(item);
        (result as Poll[]).push(itemModel);
      }
      return result;
    },
    getRecipient: state => (data: RawRecipient) => {
      if (state.recipients[data.id]) {
        state.recipients[data.id].setData(data)
      } else {
        Vue.set(state.recipients, data.id, new Recipient(data))
      }
      return state.recipients[data.id]
    },
    getRecipients: (state, getters) => (recipientsData: RawRecipient[], returnArray: boolean = true) => {
      const result = returnArray ? [] : {};
      for (const recipientData of recipientsData) {
        const recipient = getters.getRecipient(recipientData);
        if (returnArray) {
          (result as Recipient[]).push(recipient);
        } else {
          (result as { [userId: string]: Recipient })[recipient.getId()] = recipient;
        }
      }
      return result;
    }
  },
  mutations: {
  },
  actions: {
    async create (context, data) {
      const response = await context.dispatch('apiRequest', {
        method: API.poll.create,
        data
      }, {root: true})
      return response;
    },
    async get (context, id) {
      const response = await context.dispatch('apiRequest', {
        method: API.poll.get,
        data: {poll_id: id},
        flag: 'silent'
      }, {root: true})
      return context.getters.getPoll(response);
    },
    async update (context, data) {
      const response = await context.dispatch('apiRequest', {
        method: API.poll.update,
        data
      }, {root: true})
      return response;
    },
    async find (context, data) {
      const response = await context.dispatch('apiRequest', {
        method: API.poll.find,
        data,
        flag: 'silent'
      }, {root: true})
      return {polls: context.getters.getPolls(response.polls), count: response.total || 0};
    },
    async addFilter (context, data) {
      const response = await context.dispatch('apiRequest', {
        method: API.poll.rcptAddFilter,
        data,
        flag: 'ignoreTimeout'
      }, {root: true})
      return response;
    },
    async removeFilter (context, data) {
      const response = await context.dispatch('apiRequest', {
        method: API.poll.rcptRemoveFilter,
        data
      }, {root: true})
      return response;
    },
    async addIds (context, data) {
      const response = await context.dispatch('apiRequest', {
        method: API.poll.rcptAddIds,
        data,
        flag: 'ignoreTimeout'
      }, {root: true})
      return response;
    },
    async removeIds (context, data) {
      const response = await context.dispatch('apiRequest', {
        method: API.poll.rcptRemoveIds,
        data
      }, {root: true})
      return response;
    },
    async rcptFind (context, query) {
      const response = await context.dispatch('apiRequest', {
        method: API.poll.rcptFind,
        data: query,
        flag: 'silent'
      }, {root: true})
      return {rcpts: context.getters.getRecipients(response.rcpts), count: response.total}
    },
    async delete (context, id) {
      const response = await context.dispatch('apiRequest', {
        method: API.poll.delete,
        data: {poll_id: id}
      }, {root: true})
      return response;
    },
    async cancel (context, id) {
      const response = await context.dispatch('apiRequest', {
        method: API.poll.cancel,
        data: {poll_id: id}
      }, {root: true})
      return response;
    },
    async resend (context, id) {
      const response = await context.dispatch('apiRequest', {
        method: API.poll.resend,
        data: {poll_id: id}
      }, {root: true})
      return response;
    },
    async resultsXlsx (context, id) {
      const response = await context.dispatch('apiRequest', {
        method: API.poll.resultsXlsx,
        data: {poll_id: id}
      }, {root: true})
      return response;
    }
  }
}

export default store